const styles = theme => ({
  toastr: {
    // cursor: 'pointer',
    width: '420px !important',
    [theme.breakpoints.up('lg')]: {
      width: '520px !important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '420px !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '320px !important',
    },
  },
  toastrSM: {
    // cursor: 'pointer',
    width: '420px !important',
    [theme.breakpoints.up('lg')]: {
      width: '420px !important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '380px !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '320px !important',
    },
  },
});

export default styles;
